<template>

  <div id="Allcoures"  class="well" style="padding: 0 1em;">

    <b-tabs content-class="mt-3" justified>

          <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
            <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF">
              <thead class="ncut-thead-menu">
                  <tr>
                    <th style="min-width: 2em;">序號</th>
                  <th style="min-width: 28em;">課程名稱</th>
                  <th style="min-width: 5em;">上課日期</th>
                   <th style="min-width: 5em;">學費</th>
                    <th style="min-width: 5em;">招生人數(名額/已報名)</th>
                     <th style="min-width: 5em;">報名</th>
                  </tr>
              </thead>
              <tbody class="ncut-tbody-menu">
                <tr v-for="(item, index) in filteredDocs" :key="item.cid" :index="item.cid" :name="item.cid"
                  v-bind:style="{'background': (selectedRowIndex==index? headerColor: '')}"
                  @click="selectedRowIndex=index">
                   <td style="text-align: right;">{{(currentPage-1)*pageSize+index+1}}</td>
                  <td style="text-align: left;">
                      <!-- <a v-bind:href="'/CourseDetailView/'+item.cid"> {{item.courseClass}}</a> -->
<router-link :to="{path: '/CourseDetail/' ,query: {cid: item.cid }}"> {{item.courseClass}} </router-link>
                    </td>
                  <td style="text-align: left;">{{item.sdate}}</td>
                    <td style="text-align: left;">{{item.classCost}}</td>
                      <td style="text-align: left;">{{item.primaryList}}/{{item.primaryList}}</td>
                        <td style="text-align: left;"><button class="btn btn-outline-success" type="button">報名進行中</button></td>

                </tr>
              </tbody>
          </table>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total>pageSize" />
          </div>

      </b-tabs>

  </div>
</template>

<script>
import * as tools from '../tool'
export default {
  name: 'Allcoures',
  data () {
    return {
      total: 0,
      isIE: false,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      attributesClassID: '',
      queryInfo: {
        sysId: 0

      }

    }
  },
  computed: {

    	filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  created () {
    console.log('======created View =====')
    this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1

    this.attributesClassID = this.$route.query.attributesClassID
    if (tools.isNull(this.attributesClassID)) {
      this.attributesClassID = 0
    }
    if (this.attributesClassID == 0) { this.attributesClassID = '' }

    const vm = this
    this.mode = (this.id == 0 ? 1 : 2)
    this.$http.get('./WebApi/ociaRep/GetociaRepList/'.concat(vm.attributesClassID))
      .then((response) => {
        if (!tools.isNull(response)) {
          vm.inputData = response.data
          console.log(vm.inputData)
        }
      })
      .catch(function (error) {
        tools.showAlert(vm.inputData, 'danger', '網路連線失敗' + error)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
